import type {
  MealLogRecord,
  MealRecord,
  MealNutritionalInfoRecord,
} from '~/powersync/generated/schema';
import type { NutritionPreviewProps } from '@/features/meal/components/nutrition-preview/NutritionPreview';

/**
 * MealLog with joined Meal and nutritional information
 */
export interface MealLogWithDetails extends MealLogRecord {
  meal: MealRecord | null;
  nutritionalInfo: MealNutritionalInfoRecord | null;
}

/**
 * Summary data for meals in a date range
 * Reuses NutritionPreviewProps for consistency with existing meal components
 */
export interface MealSummaryData extends NutritionPreviewProps {
  mealCount: number;
}

/**
 * MealLog grouped by meal type with summary
 */
export interface MealLogsByType {
  BREAKFAST: MealLogWithDetails[];
  LUNCH: MealLogWithDetails[];
  DINNER: MealLogWithDetails[];
  SNACK: MealLogWithDetails[];
}
